const statistics = [
  { label: 'CÔNG TRÌNH ĐÃ HOÀN THÀNH', number: 1100 },
  { label: 'CÁN BỘ NHÂN VIÊN', number: 300 },
  { label: 'KHÁCH HÀNG HÀI LÒNG', number: 1100 },
  { label: 'BỘ QUY TRÌNH', number: 150 },
  { label: 'CÔ LAO CÔNG ĐƯỢC ĐÀO TẠO', number: 200 },
];

export default statistics;
